/**
 * Truncates editorial copy (region/collection descriptions) to a length
 * suitable for a meta description tag, breaking at a word boundary rather
 * than mid-word. Returns the input unchanged when it already fits.
 */
export function truncateAtWord(text: string, maxLen = 200): string {
  const trimmed = text.trim();
  if (trimmed.length <= maxLen) return trimmed;
  const cut = trimmed.slice(0, maxLen);
  const lastSpace = cut.lastIndexOf(" ");
  const base = lastSpace > 0 ? cut.slice(0, lastSpace) : cut;
  return `${base.trim()}…`;
}
